import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "";
export const method = "PUT";
export const operationId = "workwearExpressCurrencyCurrencyManagementV1UpdatePut";
export const path = "/V1/carts/mine/currency";
export interface Body {
    currencyCode: string;
}
export type Response = Response200 | Response401 | ResponseDefault;
export type Response200 = void;
export type Response401 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "putJSON">;
export function execute(body: Body, effects: MinimalEffects): Observable<Response200> {
    return effects.putJSON(effects.apiUrl(operationId)(path, undefined), body, effects.restHeaders({})) as any;
}
